import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { FiEdit, FiPrinter } from 'react-icons/fi';
import { firestore } from '../../../config/firebase';
import { deleteSale } from '../../../store/actions/saleActions';
import { updateProduct } from '../../../store/actions/productActions';
import defaultImg from '../../../assets/img/default/carpet.svg';
import Receipt from '../../UIComponents/Receipt';
import Swal from 'sweetalert2';
import lang from '../lang';
import '../NewSale/NewSale.css';
import './SaleDetails.css';
import ReactToPrint from 'react-to-print';

class NewSale extends Component {
    state = {
        progress: 0,
        msg: '',
        msgStatus: false,
        msgType: 'success',
        note: '',
        noteBtn: true,
        salePrice: 0,
        piecesForSale: 1,
        totalValue: 0,
        paymentType: 'cash',
        productId: '',
        paymentStatus: 'paid',
        active: false,
        roll: 0,
        rollLength: 0,
        toggleSalePage: {
            sale: true,
            payment: false
        },
        tab: {
            sale: true,
            detail: false
        }
    }

    componentDidMount() {
        const { id } = this.props.match.params;

        const currentSale = this.props.sales.find((item) => item.id === id)
        this.setState({ id, ...currentSale, active: false });
        console.log(currentSale)
    }

    removeSaleHandler = () => {
        const { id } = this.state;
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.value) {
                // Find the sales and delete
                firestore.collection('users')
                    .doc(this.props.user.id)
                    .collection('sales')
                    .doc(id).delete();
                // Remove the sale from sales' collection
                this.props.deleteSale(id);

                // Find the product and add current sales sold pieces number to product piece

                // const currentProduct = this.props.products.find(item => item.id === productId);
                // firestore.collection('users')
                //     .doc(this.props.user.id)
                //     .collection('products')
                //     .doc(productId).update({ piece: currentProduct.piece + piecesForSale });
                // // update products after updating the products piece filed
                // this.props.updateProduct({ ...currentProduct, piece: currentProduct.piece + piecesForSale });

                Swal.fire({
                    type: 'success',
                    title: 'The sale has been deleted successfullty',
                    confirmButtonText: 'Ok'
                }).then((result) => {
                    if (result.value) {
                        this.props.history.push('/sales')
                    }
                })
            }
        })

    }
    toggleSaleDetailsTab = (event) => {
        const { name } = event.target;
        const data = name === 'sale' ? 'details' : 'sale';

        this.setState(prevState => {
            return { tab: { [name]: true, [data]: false } }
        });
    }

    toggleSalePage = (event) => {
        const { name } = event.target;
        const data = name === 'sale' ? 'payment' : 'sale';

        this.setState(prevState => {
            return { toggleSalePage: { [name]: false, [data]: true } }
        });
    }

    render() {
        const { sale, detail } = this.state.tab;
        const {
            design,
            quality,
            title,
            category,
            color,
            dimension,
            total,
            importPrice,
            salePrice,
            inStock,
            info,
            buttons: { edit },
            sale: {
                saleTab, detailTab, paymentTitle, paymentTitle2, paymentTitle3, nextBtn, backBtn, date, pieces, price,
                customer: { ctTitle, ctName, ctDue, ctPhone, ctAddress, ctDate }
            },
            payment
        } = lang[this.props.user.lang || 'en'];

        const itemSalePrice = this.props.user.currency === 'UZS' && this.state.exchange ? parseInt(this.state.totalValue).toLocaleString() : this.state.salePriceAfterExchange;

        return (
            <div className="container mt-5 mb-5 pb-5">
                <div id="new-sale" className="bg-white text-center">
                    {/* =======  Left side of the ui   ======= */}
                    <div id="sale-left" className={`pt-5 ${this.state.toggleSalePage.sale ? 'show-sale' : 'hide-sale'}`}>
                        <div id="sale-img-wrapper">
                            <img src={this.state.img || defaultImg} onError={(e) => e.target.src = defaultImg} alt="carpet" />
                        </div>
                        <h3 className="mt-3 price">
                            {itemSalePrice}
                            <sup><small>{this.props.user.currency}</small></sup>
                            {/* <br /><small className="text-success ml-auto">(+{itemProfit}) <sup>{this.props.user.currency}</sup></small>  */}
                        </h3>
                        <button
                            id="sale-page-next"
                            className="btn btn-sm btn-outline-success"
                            name="sale"
                            onClick={(e) => this.toggleSalePage(e)}
                        >{nextBtn} =></button>
                    </div>
                    {/* =======  Sale right side   ======= */}
                    <div id="sale-right" className={`${this.state.toggleSalePage.payment ? 'show-sale' : 'hide-sale'}`}>
                        <ul className="nav nav-tabs mb-3" id="myTab" role="tablist">
                            <li className="nav-item">
                                <button
                                    href="##"
                                    className={`nav-link ${sale ? 'active' : ''}`}
                                    name="sale"
                                    onClick={this.toggleSaleDetailsTab}
                                >{saleTab}</button>
                            </li>
                            <li className="nav-item">
                                <button
                                    href="##"
                                    className={`nav-link ${detail ? 'active' : ''}`}
                                    name="detail"
                                    onClick={this.toggleSaleDetailsTab}
                                >{detailTab}</button>
                            </li>
                        </ul>

                        <div id="sale-details" style={{ display: sale ? 'block' : 'none' }} className="text-left">
                            <h5>{title}</h5>
                            <table className="table table-sm table-bordered">
                                <tbody>
                                    <tr>
                                        <td>{date}</td>
                                        <th>
                                            <small>{new Date(this.state.updatedAt).toLocaleString()}</small>
                                        </th>
                                    </tr>
                                    <tr>
                                        <td>{price}</td>
                                        <th><span className="main-info">{itemSalePrice} <sup>{this.props.user.currency}</sup>/each</span></th>
                                    </tr>
                                    <tr>
                                        <td>{pieces}</td>
                                        <th><span className="main-info">{this.state.roll > 0 ? this.state.piecesForSale + ' m' : this.state.piecesForSale}</span></th>
                                    </tr>
                                    <tr>
                                        <td>{paymentTitle2}</td>
                                        <th className="text-capitalize"><span className="main-info">{payment[this.state.paymentStatus]}</span></th>
                                    </tr>
                                    <tr>
                                        <td>{paymentTitle}</td>
                                        <th><span className="main-info">{payment[this.state.paymentType]}</span></th>
                                    </tr>
                                    {
                                        this.state.paymentType === 'mixed' ?
                                            (
                                                <React.Fragment>
                                                    <tr>
                                                        <td>Cash Amount</td>
                                                        <th className="text-capitalize"><span className="main-info">{this.state.mixedPaymentCash} <sup>{this.props.user.currency}</sup></span></th>
                                                    </tr>
                                                    <tr>
                                                        <td>Card Amount</td>
                                                        <th><span className="main-info">{this.state.mixedPaymentCard} <sup>{this.props.user.currency}</sup></span></th>
                                                    </tr>
                                                    <tr>
                                                        <td>Bank Amount</td>
                                                        <th><span className="main-info">{this.state.mixedPaymentBank} <sup>{this.props.user.currency}</sup></span></th>
                                                    </tr>
                                                </React.Fragment>
                                            )
                                            :
                                            null
                                    }
                                    {
                                        this.state.paymentStatus === 'debt' ?
                                            (
                                                <React.Fragment>
                                                    <tr>
                                                        <td colSpan="2" className="text-center text-success"><b>{ctTitle}</b></td>
                                                    </tr>
                                                    <tr>
                                                        <td>{ctName}:</td>
                                                        <th className="text-capitalize"><span className="main-info">{this.state.customerName}</span></th>
                                                    </tr>
                                                    <tr>
                                                        <td>{ctDue}</td>
                                                        <th><span className="main-info">{(this.state.customerDebtAmount).toLocaleString()} <sup>{this.props.user.currency}</sup></span></th>
                                                    </tr>
                                                    <tr>
                                                        <td>{ctPhone}:</td>
                                                        <th><span className="main-info">{this.state.customerPhone}</span></th>
                                                    </tr>
                                                    <tr>
                                                        <td>{ctAddress}:</td>
                                                        <th><span className="main-info">{this.state.customerAddress}</span></th>
                                                    </tr>
                                                    <tr>
                                                        <td>{ctDate}:</td>
                                                        <th><span className="main-info">{new Date(this.state.customerPayDeadline).toLocaleDateString()}</span></th>
                                                    </tr>
                                                </React.Fragment>
                                            )
                                            :
                                            null
                                    }

                                </tbody>

                            </table>
                            <h5 className="my-3">{paymentTitle3}</h5>
                            <p>
                                {this.state.note}
                            </p>

                            <div className="border-top pt-2 flex-wrap" id="sale-details-actions">
                                <Link to={`/sales/${this.state.id}/edit`} className="btn btn-sm btn-outline-success mr-2">{edit} <FiEdit /></Link>
                                {/* <button className="btn btn-sm btn-outline-danger" onClick={() => this.removeSaleHandler()}> {deleteBtn} <FiTrash2 /></button> */}
                                <ReactToPrint
                                    trigger={() => <span className="d-print-none btn btn-outline-dark btn-sm"><FiPrinter /> Receipt </span>}
                                    content={() => this.receiptRef}
                                />
                                <Receipt
                                    ref={(ref) => this.receiptRef = ref}
                                    logo={this.props.user.img}
                                    user={{ ...this.props.user }}
                                    {...this.state}
                                />
                            </div>
                            <button
                                id="sale-page-next"
                                className="btn btn-sm btn-outline-secondary"
                                name="payment"
                                onClick={(e) => this.toggleSalePage(e)}
                            >{backBtn}</button>
                        </div>
                        <div id="sale-product-details" style={{ display: detail ? 'block' : 'none' }} className="text-left">
                            <h3 className="mt-3 mb-0"><span className="text-uppercase">{this.state.name}</span> </h3>
                            <p className="border-bottom company-name">{this.state.brand}</p>
                            <h5>{title}</h5>
                            <table className="table table-sm table-bordered">
                                <tbody>
                                    <tr>
                                        <td>{design}:</td>
                                        <th><span className="main-info">{this.state.code}</span></th>
                                    </tr>
                                    <tr>
                                        <td>{quality}:</td>
                                        <th className="text-capitalize"><span className="main-info">{this.state.quality}</span></th>
                                    </tr>
                                    <tr>
                                        <td>{category}:</td>
                                        <th className="text-capitalize"><span className="main-info">{this.state.category}</span></th>
                                    </tr>
                                    <tr>
                                        <td>{color}:</td>
                                        <th id="color-th"><span className="main-info">{this.state.color}</span> <span className="color-style" style={{ background: this.state.colorCode }}></span></th>
                                    </tr>
                                    <tr>
                                        <td>{dimension}:</td>
                                        <th><span className="main-info">{this.state.width}</span> x <span className="main-info">{this.state.lengthLong}</span> m</th>
                                    </tr>
                                    <tr>
                                        <td>{total}:</td>
                                        <th><span className="main-info">{this.state.totalSize}</span> m<sup>2</sup> </th>
                                    </tr>
                                    <tr>
                                        <td>{importPrice}:</td>
                                        <th><span className="main-info">{this.props.user.currency === 'UZS' ? parseInt(this.state.factoryPrice * this.state.currencyRate).toLocaleString() : this.state.factoryPrice}</span> {this.props.user.currency}/m<sup>2</sup></th>
                                    </tr>
                                    <tr>
                                        <td>{salePrice}:</td>
                                        <th><span className="main-info">{this.props.user.currency === 'UZS' ? parseInt(this.state.merchantPrice * this.state.currencyRate).toLocaleString() : this.state.merchantPrice}</span> {this.props.user.currency}/m<sup>2</sup></th>
                                    </tr>
                                    <tr>
                                        <td>{inStock}:</td>
                                        <th><span className="main-info">{this.state.piece}</span></th>
                                    </tr>
                                </tbody>

                            </table>
                            <h5 className="my-3">{info}</h5>
                            <p>
                                {this.state.content}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )


    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        sales: state.sales.sales,
        products: state.products.products,
        currency: state.currency
    }
}
const mapDispatchToProps = dispatch => {
    return {
        deleteSale: (id) => dispatch(deleteSale(id)),
        updateProduct: (product) => dispatch(updateProduct(product))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewSale));